import api from "@/modules/shared/api/axios";

// The marketing site's pages, offered when a document cannot be shown in the popup.
export const LEGAL_PAGE_URLS = {
  terms: "https://tarhplatform.com/terms",
  privacy: "https://tarhplatform.com/privacy",
};

// Loaded once per document and language for the session; a failed request isn't kept, so Retry asks again.
const loadedDocuments = new Map();

export const fetchLegalDocument = async (type, lang) => {
  const key = `${type}:${lang}`;
  if (!loadedDocuments.has(key)) {
    const resp = await api.get(`/legal/${type}`, { forceRefresh: true });
    loadedDocuments.set(key, resp?.data?.data ?? null);
  }
  return loadedDocuments.get(key);
};
